module.exports = __webpack_public_path__ + "static/malvinnathan-95985284764e9915869547472c7a8ed3.png";